<script>
import Layout from '@layouts/main'
import {
  scoreReportMethods,
  customerMethods,
  toasterMethods,
} from '@state/helpers'
import constant from '@constants/constant'
export default {
  page: {
    meta: [{ name: 'description', content: 'Reports' }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      pageNumber: 1,
      pageSize: 5000,
      selectedCustomers: '',
      previousSelectedCustomers: '',
      customerUser: '',
      currentUserId: '',
      timeZone: constant.defaultTimeZone,
      timeZones: constant.timeZones,
      headerTitle: 'Score Report',
      disableDownload: false,
      showSpinner: true,
      showTableGrid: false,
      alertMessage: '',
      ssn: '',
      selectedComponent: '',
      startdate: '',
      validateDate: '',
      previousStartdate: '',
      previousEnddate: '',
      enddate: '',
      maxdate: '',
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
        {
          text: 'Management',
          active: true,
        },
        {
          text: 'Management Reports',
          active: true,
        },
        { text: 'Score Report', active: true },
      ],
      customers: [],
      options: [5, 10, 15],
      rows: 0,
      currentPage: 1,
      sortByColoumn: '',
      rowsSelected: {},
      sortByDirection: 0,
      perPage: 15,
      row: {},
      items: [],
      branchStatus: true,
      fileds: [
        {
          key: 'fileNumber',
          label: 'File Number',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'customerName',
          label: 'Customer Name',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'customerAccNumber',
          label: 'Customer Number',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },

        {
          key: 'referenceNumber',
          label: 'Reference Number',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '120px' },
        },

        {
          key: 'orderDate',
          label: 'Order Date',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'applicantFirstName',
          label: 'Applicant First Name',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'applicantMiddleName',
          label: 'Applicant Middle Name',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'applicantLastName',
          label: 'Applicant Last Name',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'coApplicantFirstName',
          label: 'Co-Applicant First Name',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'coApplicantMiddleName',
          label: 'Co-Applicant Middle Name',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'coApplicantLastName',
          label: 'Co-Applicant Last Name',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'coApplicantNameSuffix',
          label: 'Co-Applicant Name Suffix',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'applicantEQFScore',
          label: 'Applicant EQF score',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'applicantEXPScore',
          label: 'Applicant EXP score',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'applicantTUCScore',
          label: 'Applicant TUC score',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'applicantMidScore',
          label: 'Applicant Middle score',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },

        {
          key: 'coApplicantEQFScore',
          label: 'Co-Applicant EQF score',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'coApplicantEXPScore',
          label: 'Co-Applicant EXP score',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'coApplicantTUCScore',
          label: 'Co-Applicant TUC score',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
        {
          key: 'coApplicantMidScore',
          label: 'Co-Applicant Middle score',
          sortable: true,
          class: 'text-left',
          thStyle: { width: '150px' },
        },
      ],
      selectedCustomerName: '',
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.auth.currentUser.userInfo
    },
  },
  created() {
    if (!this.$_canAccessCpAdmin || !this.$_canAccessCustomerAdmin) {
      this.$router.push('home')
    }
  },
  mounted() {
    this.getCustomers()
    this.getLastMonthDates()
    this.getMaxDateLimit()
  },
  methods: {
    ...scoreReportMethods,
    ...customerMethods,
    ...toasterMethods,
    changeEndDate() {
      if (this.startdate.trim().length === 10) {
        let splitdata = this.startdate.split('/')
        let lastMonthSplitdata = this.validateDate.split('/')
        if (
          Number(splitdata[0]) > Number(lastMonthSplitdata[0]) ||
          Number(splitdata[2]) > Number(lastMonthSplitdata[2])
        )
          this.enddate = this.maxdate
      }
    },
    getMaxDateLimit() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.maxdate = `${month}-${today.getDate()}-${today.getFullYear()}`
    },
    getLastMonthDates() {
      var dt = new Date()
      dt.setDate(1)
      this.startdate = `${dt.getMonth()}/${dt.getDate()}/${dt.getFullYear()}`
      this.validateDate = this.startdate

      dt.setHours(-1)
      this.enddate = `${dt.getMonth() + 1}/${dt.getDate()}/${dt.getFullYear()}`
    },
    getCustomers() {
      this.showSpinner = true
      this.customerUser = ''
      return this.fetchTransactionCustomersByUserId({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
        .then((response) => {
          let i = 0
          this.customers.push({
            groupname: 'All (Click to select/deselect all)',
            items: [],
          })
          for (i = 0; i < response.customers.length; i++) {
            let eachCustomer = response.customers[i]
            this.customers[0].items.push({
              text: eachCustomer.customerAccNumber + '-' + eachCustomer.name,
              value: eachCustomer.customerId,
            })
          }
          this.showSpinner = false
        })
        .catch((error) => {
          this.authError = error
          this.setAlert({
            title: constant.imageHeaderError,
            msg: constant.errorMessage,
            variant: constant.errorMessagetype,
          })
        })
        .finally(() => {
          this.showSpinner = false
        })
    },

    buildScoreReportSearchModel() {
      let selectedCustomerValues = []
      if(this.selectedCustomers.length !== this.customers[0].items.length){
        selectedCustomerValues = this.selectedCustomers.map((item)=>{
          return item.value
        })
      }
      return {
         pageSize: this.perPage,
         selectedCustomer: selectedCustomerValues,
         pageNumber: this.currentPage,
         sortBy: this.sortByColoumn,
         sortDirection: this.sortByDirection,
         fromDate: this.startdate,
         toDate: this.enddate,
         timeZone: this.timeZone,
         isBranch: this.branchStatus,
      }
    },
    onGenerateReport(event) {
      let userInfo = this.$store.state.auth.currentUser.userInfo
      this.currentUserId = userInfo.userId
      this.$validator.validateAll().then((response) => {
        if (response) {
          this.showSpinner = true
          this.showTableGrid = true
          this.getScoreRecords()
        }
      })
    },

    getScoreRecords() {
      this.fetchScoreReport(this.buildScoreReportSearchModel())
        .then((response) => {
          this.showSpinner = false
          this.items = []
          this.rows = 0

          if (
            response.data === '' ||
            response.data == null ||
            response.data.scoreList === '' ||
            response.data.scoreList == null
          ) {
            //   alert(constant.errorMessage)
          } else {
            this.items = response.data.scoreList
            this.items.map((resp) => {
              resp.fileNumber =
                resp.fileNumber !== null ? resp.fileNumber.trim() : ''
            })
            if (this.items !== null && this.items.length !== 0)
              this.rows = response.data.totalRecordsCount
            else this.rows = 0
          }
        })
        .catch((error) => {
          this.showSpinner = false
          this.setAlert({
            title: constant.imageHeaderError,
            msg: constant.errorMessage,
            variant: constant.errorMessagetype,
          })
          this.errorLog = error
        })
    },
    paginationEvent(currentPage) {
      if (this.currentPage !== currentPage) {
        this.showSpinner = true
        this.currentPage = currentPage
        if (
          this.rowsSelected.startdate !== '' &&
          this.rowsSelected.enddate !== ''
        ) {
          this.showSpinner = true
          this.getScoreRecords()
        }
      }
    },
    rowPerPageCount(pageValue) {
      this.perPage = parseInt(pageValue)
      this.currentPage = 1
      if (this.rows !== 0) {
        this.showSpinner = true
        this.getScoreRecords()
      }
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== null && ctx.sortBy !== '') {
        this.sortByColoumn = ctx.sortBy
        this.sortByDirection = ctx.sortDesc ? 1 : 0
        if (this.rows !== 0) {
          this.showSpinner = true
          this.getScoreRecords()
        }
      }
    },
    downloadReport() {
      if (this.showTableGrid) {
        this.disableDownload = true
        return this.downloadScoreReport(this.buildScoreReportSearchModel())
          .then((response) => {
            this.disableDownload = false
          })
          .catch((error) => {
            this.disableDownload = false
            this.showSpinner = false
            this.setAlert({
              title: constant.imageHeaderError,
              msg: constant.errorMessage,
              variant: constant.errorMessagetype,
            })
            this.authError = error
          })
      }
    },
  },
}
</script>

<template>
  <section :class="$style.overflowX">
    <Layout>
      <BaseSpinner v-if="showSpinner" />
      <BaseBreadcrumb class="px-3" :crumbs="breadcrumbs" />
      <div class="body--wrapper mt-1 bg-white container">
        <BaseTitleReportMenu
          :fields="fileds"
          :heade-title="headerTitle"
          show-download
          :disable-download="disableDownload"
          @downloadTo="downloadReport"
        />
        <div class="body--wrapper mt-1 bg-white container">
          <b-form>
            <b-row align-v="center">
              <b-col md="3">
                <BaseELabel mark-required label="Start Date" size="sm" />
                <BaseDate
                  v-model="startdate"
                  v-validate="'required'"
                  :field-id="'startDate'"
                  type="date"
                  name="startdate"
                  data-vv-as="Start Date"
                  :max="maxdate"
                  :class="{
                    input: true,
                    'is-danger': errors.has('startdate'),
                  }"
                  @on-change="changeEndDate"
                ></BaseDate>
                <div class="error">
                  {{ errors.first('startdate') }}
                </div>
              </b-col>
              <b-col md="3">
                <BaseELabel mark-required label="End Date" size="sm" />
                <BaseDate
                  v-model="enddate"
                  v-validate="'required'"
                  :field-id="'endDate'"
                  type="date"
                  name="enddate"
                  data-vv-as="End Date"
                  :initial-date="enddate"
                  :min="startdate"
                  :max="maxdate"
                  :class="{
                    input: true,
                    'is-danger': errors.has('enddate'),
                  }"
                ></BaseDate>
                <div class="error">
                  {{ errors.first('enddate') }}
                </div>
              </b-col>
              <b-col md="3" class="d-inline-block">
                <BaseELabel mark-required label="Customer" size="sm" />
                <BaseMultiSelect
                  v-model="selectedCustomers"
                  v-validate="'required'"
                  type="text"
                  :options="customers"
                  :multiple="true"
                  name="selectedCustomers"
                  mark-required
                  placeholder="Select"
                  data-vv-as="Customer[s]"
                  group-label="groupname"
                  group-values="items"
                  :group-select="true"
                  label="text"
                  track-by="value"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :class="$style.dropOptionstyle"
                ></BaseMultiSelect>
                <div class="error">
                  {{ errors.first('selectedCustomers') }}
                </div>
              </b-col>

              <b-col md="2" class="mt-4">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="branchStatus"
                  name="checkbox-1"
                  value="true"
                  unchecked-value="false"
                >
                  Include Branches
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2" class="mt-3">
                <BaseEButton
                  type="button"
                  name="search"
                  @click="onGenerateReport"
                >
                  Get Report
                </BaseEButton>
              </b-col>
            </b-row>
          </b-form>
        </div>
        <div v-if="showTableGrid" class="body--wrapper mt-1 bg-white container">
          <BaseDataTable
            :items="items"
            :fields="fileds"
            :options="options"
            :total-rows="rows"
            :per-page="perPage"
            :row="row"
            show-eye
            show-link
            :current-page="currentPage"
            showdatatablefooter
            @rowPerPageChange="rowPerPageCount"
            @paginationEvent="paginationEvent"
            @sortingChanged="sortingChanged"
          />
        </div>
      </div>
    </Layout>
  </section>
</template>
<style lang="scss" module>
@import '@design';

.overflowX {
  overflow-x: hidden;
}
.status {
  margin: 0.625rem 0;
  font-size: $size-content-font;
  font-weight: $label-font-weight;
  color: $color-text-gray;
}

.labelHeader {
  font-size: $size-font-sub-header;
  font-weight: $heading-font-weight;
  color: $color-subheader;
}

.btnHover:hover {
  color: $color-text-white;
  background-color: #5a6268 !important;
}

.containerWidth {
  max-width: $size-container-max-width;
}

.dropOptionstyle option {
  font-size: 16px;
}

.alertMsgPosition {
  position: absolute;
  top: 350px;
  right: 0;
}
.pagecontent {
  bottom: 90px;
}
.pagebanner {
  // height: 200px;
  // opacity: 0.8;
}
.skylogo {
  left: 0;
  border-bottom: 2px solid;
}
.bannertitle {
  top: 38%;
  left: 0%;
  font-size: 3rem;
  color: #23a98a;
}
</style>
